import { render, staticRenderFns } from "./icon-menu.vue?vue&type=template&id=5d3fb5f9&"
import script from "./icon-menu.vue?vue&type=script&lang=js&"
export * from "./icon-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports